<template>
  <div
    :class="`px-3 vendor-card-${vendor.id} ${
      loggedInUser.isAdmin || loggedInUser.isVendor ? 'has-add-to-network' : ''
    }`"
    @click="$emit('show-vendor', $event)"
  >
    <div
      class="card shadow-card cursor-pointer bg-dark text-light"
      :class="contentClass"
    >
      <img src="/images/profile-cover.jpg" alt="..." class="card-img-top" />
      <div class="card-body text-center">
        <a
          href="#"
          @click="$event.preventDefault()"
          class="avatar avatar-xl card-avatar card-avatar-top position-relative"
        >
          <img
            :src="logo"
            class="avatar-img rounded-circle border border-2 border-card"
            alt="..."
          />
        </a>

        <h2 class="card-title text-capitalize" v-if="!searchText">
          {{ vendor.name }}
        </h2>
        <h2
          class="card-title"
          v-if="searchText"
          v-html="
            vendor.name.replace(
              new RegExp(searchText, 'ig'),
              `<b class='text-success'>${searchText}</b>`
            )
          "
        ></h2>
        <p class="card-text text-muted">
          <small v-if="!searchText">{{ vendor.bioExcerpt }}</small>
          <small
            v-if="searchText"
            v-html="
              vendor.bioExcerpt.replace(
                new RegExp(searchText, 'ig'),
                `<b class='text-success'>${searchText}</b>`
              )
            "
          ></small>
        </p>
        <div v-if="vendor.rating && vendor.rating.value > 0">
          <icon
            type="star"
            v-for="(n, i) in vendor.rating.value.toString()"
            :key="i"
          />
          <icon
            type="star-half-alt"
            v-if="vendor.rating.value.toString().indexOf('.') > -1"
          />
        </div>
        <div v-if="vendor.rating.count > 0">
          {{ vendor.rating.count }} Rating{{
            vendor.rating.count > 1 ? "s" : ""
          }}
        </div>
        <i
          class="fas fa-map-marker-alt marker-info mt-3 text-success"
          v-tooltip.top="'Click to view more locations on the map'"
          v-if="showInfo && vendor.locations && vendor.locations.length > 1"
        ></i>
        <div class="connect-btn">
          <button
            class="btn mt-3 btn-success btn-block"
            data-v-step="connectWithVendor"
            @click="
              vendor.prevent_referrals ||
              (vendor.prevent_public_referrals &&
                !loggedInUser.isVendor &&
                !loggedInUser.isAdmin)
                ? viewVendor($event)
                : connectWithVendor($event, vendor)
            "
          >
            <icon
              class="mr-2"
              :type="
                vendor.prevent_referrals ||
                (vendor.prevent_public_referrals && !loggedInUser.isVendor)
                  ? 'user'
                  : 'plug'
              "
            />{{
              vendor.prevent_referrals ||
              (vendor.prevent_public_referrals &&
                !loggedInUser.isVendor &&
                !loggedInUser.isAdmin)
                ? "View Vendor Profile"
                : "Connect With Vendor"
            }}
          </button>
          <button
            class="btn mt-3 btn-secondary btn-block"
            data-v-step="downloadIntakeForm"
            v-if="
              !(
                vendor.prevent_referrals ||
                (vendor.prevent_public_referrals &&
                  !loggedInUser.isVendor &&
                  !loggedInUser.isAdmin)
              ) &&
              vendor.intakeFormInfo &&
              false
            "
            @click="downloadIntakeForm($event, vendor)"
          >
            <icon type="file-download" class="mr-2" />Download Intake Form
          </button>
          <button
            class="btn mt-3 btn-primary btn-block"
            data-v-step="makeBooking"
            :disabled="!vendor.booking_link"
            @click="openBooking(vendor.booking_link)"
          >
            <icon type="calendar-plus" class="mr-2" />Book an Appointment
          </button>

          <button
            :class="`btn mt-3 btn-secondary btn-block${
              vendorIsMine ? ' invisible' : ''
            }`"
            data-v-step="addToNetwork"
            v-if="loggedInUser.isAdmin || loggedInUser.isVendor"
            :disabled="
              !selectedUserVendor ||
              vendor.networks[(selectedUserVendor || {}).id || 0] == 3 ||
              vendor.loading
            "
            @click="
              vendor.networks[(selectedUserVendor || {}).id || 0] == 1 ||
              vendor.networks[(selectedUserVendor || {}).id || 0] == 2
                ? removeVendorNetwork($event, vendor)
                : addVendorToNetwork($event, vendor)
            "
          >
            <icon
              v-if="!vendor.loading"
              class="mr-2"
              :type="
                vendor.networks[(selectedUserVendor || {}).id || 0] == 1
                  ? 'ban'
                  : vendor.networks[(selectedUserVendor || {}).id || 0] == 2
                  ? 'user-minus'
                  : vendor.networks[(selectedUserVendor || {}).id || 0] == 3
                  ? 'user-times'
                  : 'user-plus'
              "
            />
            <icon
              v-if="vendor.loading"
              class="mr-2"
              type="spin fa-circle-notch"
            />{{
              vendor.networks[(selectedUserVendor || {}).id || 0] == 1
                ? "Cancel Request"
                : vendor.networks[(selectedUserVendor || {}).id || 0] == 2
                ? "Remove From My Network"
                : "Add To My Network"
            }}
          </button>
        </div>
        <div
          class="px-3 position-absolute vendor-card-footer"
          @click="$event.stopPropagation()"
        >
          <div :class="`like-container ${vendor.liked ? 'liked' : ''}`">
            <i
              v-if="vendor.likeSending"
              class="fas fa-spin fa-circle-notch mr-2"
            ></i>
            <img
              class="p-0 mr-2"
              @click="like($event, vendor)"
              :src="`${
                vendor.liked ? '/images/heart.png' : '/images/heart-alt.png'
              }`"
              v-if="!vendor.likeSending"
              :title="`${vendor.liked ? 'Unlike' : 'Like'}`"
            />
            <small>{{ vendor.numberOfLikes }}</small>
          </div>
          <div class="follow-container d-flex">
            <div
              class="d-flex justify-content-center align-items-center"
              :class="vendor.following ? 'pr-3' : ''"
            >
              <i
                v-if="vendor.followSending"
                class="fas fa-spin fa-circle-notch mr-2"
              ></i>
              <span
                v-if="!vendor.followSending"
                @click="follow($event, vendor)"
                class="follow-button"
              >
                <span class="text-decoration-underline">
                  {{ vendor.following ? "Unfollow" : "Follow" }}
                </span>
              </span>
              <span v-if="vendor.followSending">
                {{ vendor.following ? "Unfollowing..." : "Following..." }}
              </span>
            </div>
            <div v-if="vendor.following">
              <i
                v-if="vendor.subscribeSending"
                class="fas fa-spin fa-circle-notch mr-2"
              ></i>
              <img
                class="p-0 subscribe-image"
                :class="`${vendor.subscribed ? 'unsubscribe' : ''}`"
                @click="subscribe($event, vendor)"
                :src="`${
                  vendor.subscribed
                    ? '/images/unsubscribe.png'
                    : '/images/subscribe.png'
                }`"
                v-if="!vendor.subscribeSending"
                :title="`${vendor.subscribed ? 'Unsubscribe' : 'Subscribe'}`"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Swal from "sweetalert2";
import Auth from "../../../auth";

export default {
  name: "VendorCard",
  props: [
    "vendor",
    "searchText",
    "showInfo",
    "selectedUserVendor",
    "center",
    "contentClass",
  ],
  data() {
    return {
      selectedVendor: undefined,
    };
  },
  computed: {
    ...mapState(["vendors", "loading"]),
    logo: function () {
      if ((this.vendor || {}).logo) {
        return this.vendor.logoUrl;
      }
      return `/images/no-logo.png`;
    },
    loggedInUser: function () {
      return Auth.user.get();
    },
    vendorIsMine: function () {
      if ((this.vendor || {}).id == (this.selectedUserVendor || {}).id) {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions({
      addVendorToMyNetwork: "networks/addVendorToNetwork",
      removeVendorFromNetwork: "networks/removeVendorFromNetwork",
      followVendor: "followers/followVendor",
      unfollowVendor: "followers/unfollowVendor",
      likeVendor: "likers/likeVendor",
      unlikeVendor: "likers/unlikeVendor",
      subscribeToVendor: "subscribers/subscribeToVendor",
      unsubscribeToVendor: "subscribers/unsubscribeToVendor",
    }),
    connectWithVendor(event, vendor) {
      event.stopPropagation();
      if (this.center) {
        this.$router.push(
          `/vendors/${vendor.id}/order?lat=${this.center.lat}&lng=${this.center.lng}`
        );
      } else {
        this.$router.push(`/vendors/${vendor.id}/order`);
      }
    },
    viewVendor(event) {
      event.stopPropagation();
      this.$emit("view-vendor-profile", event);
    },
    openBooking(link) {
      if (link.indexOf("http") > -1) {
        window.open(link, "_blank");
      } else {
        window.open(`https://${link}`, "_blank");
      }
    },
    downloadIntakeForm(event, vendor) {
      event.stopPropagation();
      window.open(vendor.intakeFormInfo);
    },
    addVendorToNetwork(event, vendor) {
      event.stopPropagation();
      if (!this.selectedUserVendor) {
        Swal.fire({
          title: "Error",
          text: "Please select vendor first from the dropdown above!",
          type: "error",
        });
        return;
      }
      if (
        vendor.networks[vendor.id] == 3 ||
        vendor.loading ||
        this.vendorIsMine
      ) {
        return;
      }
      vendor.loading = true;
      this.$forceUpdate();
      this.addVendorToMyNetwork({
        vendor_1: this.selectedUserVendor.id,
        vendor_2: vendor.id,
      }).then((success) => {
        if (success) {
          vendor.networks[this.selectedUserVendor.id] = 1;
        }
        vendor.loading = false;
        this.$forceUpdate();
      });
    },
    removeVendorNetwork(event, vendor) {
      event.stopPropagation();
      if (!this.selectedUserVendor) {
        Swal.fire({
          title: "Error",
          text: "Please select vendor first from the dropdown above!",
          type: "error",
        });
        return;
      }
      if (
        vendor.networks[vendor.id] == 3 ||
        vendor.loading ||
        this.vendorIsMine
      ) {
        return;
      }
      let text = `You are going to remove "${vendor.name}" from your network.`;
      if (vendor.networks[(this.selectedUserVendor || {}).id || 0] == 1) {
        text = `You are going to cancel the request sent to ${vendor.name}`;
      }
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success ml-4",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Yes, remove`,
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            vendor.loading = true;
            this.$forceUpdate();
            this.removeVendorFromNetwork({
              vendor_1: this.selectedUserVendor.id,
              vendor_2: vendor.id,
            }).then((success) => {
              if (success) {
                vendor.networks[this.selectedUserVendor.id] = 0;
              }
              vendor.loading = false;
              this.$forceUpdate();
            });
          }
        });
    },
    follow(event, vendor) {
      event.stopPropagation();
      event.preventDefault();
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success ml-4",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      if (vendor.following) {
        let textMessage = `You are going to unfollow "${vendor.name}"`;
        if (vendor.subscribed) {
          textMessage = `${textMessage}.<br>Your subscription will be removed.`;
        }
        swalWithBootstrapButtons
          .fire({
            title: "Are you sure?",
            html: textMessage,
            type: "warning",
            showCancelButton: true,
            confirmButtonText: `Yes, unfollow`,
            cancelButtonText: "No, cancel!",
            reverseButtons: true,
          })
          .then((result) => {
            if (result.value) {
              vendor.followSending = true;
              this.$forceUpdate();
              this.unfollowVendor({ id: vendor.id }).then((success) => {
                if (success) {
                  vendor.following = false;
                }
                vendor.followSending = false;
                this.$forceUpdate();
              });
            }
          });
      } else {
        swalWithBootstrapButtons
          .fire({
            text: "Would you like to receive updates and news from this vendor? ",
            type: "warning",
            showCancelButton: true,
            confirmButtonText: `&nbsp;&nbsp;&nbsp;Yes&nbsp;&nbsp;&nbsp;`,
            cancelButtonText: "No, Just Follow",
            showCloseButton: true,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.dismiss == "backdrop" || result.dismiss == "close") {
              return;
            }
            vendor.followSending = true;
            this.$forceUpdate();
            const isSubscriber = result.value ? result.value : false;
            this.followVendor({
              vendor_id: vendor.id,
              isSubscriber: isSubscriber,
            }).then((success) => {
              if (success) {
                vendor.following = true;
                vendor.subscribed = isSubscriber;
              }
              vendor.followSending = false;
              this.$forceUpdate();
            });
          });
      }
    },
    like(event, vendor) {
      event.stopPropagation();
      event.preventDefault();
      if (vendor.liked) {
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success ml-4",
            cancelButton: "btn btn-danger",
          },
          buttonsStyling: false,
        });
        swalWithBootstrapButtons
          .fire({
            title: "Are you sure?",
            text: `You are going to unlike "${vendor.name}"`,
            type: "warning",
            showCancelButton: true,
            confirmButtonText: `Yes, unlike`,
            cancelButtonText: "No, cancel!",
            reverseButtons: true,
          })
          .then((result) => {
            if (result.value) {
              vendor.likeSending = true;
              this.$forceUpdate();
              this.unlikeVendor({ id: vendor.id }).then((success) => {
                if (success) {
                  vendor.liked = false;
                  vendor.numberOfLikes--;
                }
                vendor.likeSending = false;
                this.$forceUpdate();
              });
            }
          });
      } else {
        vendor.likeSending = true;
        this.$forceUpdate();
        this.likeVendor({ vendor_id: vendor.id }).then((success) => {
          if (success) {
            vendor.liked = true;
            vendor.numberOfLikes++;
          }
          vendor.likeSending = false;
          this.$forceUpdate();
        });
      }
    },
    subscribe(event, vendor) {
      event.stopPropagation();
      event.preventDefault();
      if (vendor.subscribed) {
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success ml-4",
            cancelButton: "btn btn-danger",
          },
          buttonsStyling: false,
        });
        swalWithBootstrapButtons
          .fire({
            title: "Are you sure?",
            text: `You are going to unsubscribe from "${vendor.name}"`,
            type: "warning",
            showCancelButton: true,
            confirmButtonText: `Yes, unsubscribe`,
            cancelButtonText: "No, cancel!",
            reverseButtons: true,
          })
          .then((result) => {
            if (result.value) {
              vendor.subscribeSending = true;
              this.$forceUpdate();
              this.unsubscribeToVendor({
                id: vendor.id,
              }).then((success) => {
                if (success) {
                  vendor.subscribed = false;
                }
                vendor.subscribeSending = false;
                this.$forceUpdate();
              });
            }
          });
      } else {
        vendor.subscribeSending = true;
        this.$forceUpdate();
        this.subscribeToVendor({
          vendor_id: vendor.id,
        }).then((success) => {
          if (success) {
            vendor.subscribed = true;
          }
          vendor.subscribeSending = false;
          this.$forceUpdate();
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@keyframes blink-shadow {
  0% {
    transform: scale(1.05);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.05);
  }
}

@-webkit-keyframes blink-shadow {
  0% {
    transform: scale(1.05);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.05);
  }
}

.blink-shadow {
  -webkit-animation: blink-shadow 2s ease-in-out;
  -moz-animation: blink-shadow 2s ease-in-out;
  -ms-animation: blink-shadow 2s ease-in-out;
  -o-animation: blink-shadow 2s ease-in-out;
  animation: blink-shadow 2s ease-in-out;
}
.card.shadow-card {
  height: 100%;
  max-width: 20rem;
  @media (max-width: 594px) {
    margin: auto;
  }
}

.card-body {
  position: relative;
  padding-bottom: 120px;
}

.has-add-to-network {
  .card-body {
    padding-bottom: 160px;
  }
}
.connect-btn {
  position: absolute;
  width: 80%;
  bottom: 75px;
  left: 10%;
}
.marker-info {
  height: 22px;
}
.vendor-card-footer {
  height: 35px;
  background-color: rgb(216 224 255 / 0.17);
  display: flex;
  align-items: center;
  justify-content: space-between;
  bottom: -1px;
  left: -1px;
  right: -1px;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  transition: all 0.2s ease-in-out;
  &:hover {
    background-color: white;
    color: #2c7be5;
    i {
      color: #2c7be5;
    }
  }
}
.follow-container {
  .subscribe-image {
    height: 80%;
    margin-top: 10%;
    filter: drop-shadow(0px 0px 1px black);
    transition: transform 0.2s ease-in-out;
    &:hover {
      transform: scale(1.1);
    }
    &.unsubscribe {
      height: 94%;
      margin-top: 3%;
    }
  }
  .follow-button {
    transition: transform 0.2s ease-in-out;
    &:hover {
      transform: scale(1.1);
    }
  }
}
.like-container {
  i {
    color: white;
  }

  &:hover {
    color: #2c7be5;
    i {
      color: #2c7be5;
    }
  }

  img {
    padding-top: 4px;
    width: 25px;
    transition: all 0.2s ease-in-out;
    filter: drop-shadow(0px 0px 0px white);
  }

  &:hover:not(.liked) {
    img {
      transform: scale(1.1);
    }
  }

  &.liked {
    img {
      animation: follow-animation 0.5s ease-in-out infinite alternate;
      -webkit-animation: follow-animation 0.5s ease-in-out infinite alternate;
    }
  }
}
</style>
<style>
@keyframe follow-animation {
  0% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
  100% {
    transform: scale(1.1);
    -webkit-transform: scale(1.1);
  }
}

@-webkit-keyframes follow-animation {
  0% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
  100% {
    transform: scale(1.1);
    -webkit-transform: scale(1.1);
  }
}
.card.shadow-card .card-avatar {
  width: 6.125rem;
  height: 6.125rem;
  margin-top: -4.5625rem;
}
</style>
